import { render } from "./WeekCycleForSingle.vue?vue&type=template&id=243db073"
import script from "./WeekCycleForSingle.vue?vue&type=script&lang=js"
export * from "./WeekCycleForSingle.vue?vue&type=script&lang=js"

import "./WeekCycleForSingle.vue?vue&type=style&index=0&id=243db073&lang=css"

import exportComponent from "/home/runner/work/nutristudents-k12-container/nutristudents-k12-container/.vapor/build/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__